module.exports = "/assets/src/client/assets/payment-icons/mollie/directdebit.svg";